var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85,
    height: 95,
    viewBox: "0 0 85 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Custom_Size_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 95
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom_Size_2",
    "data-name": "Custom Size \\u2013 2",
    clipPath: "url(#clip-Custom_Size_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(9 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0,88.236a3.571,3.571,0,0,0,3.584,3.537h60.57a3.571,3.571,0,0,0,3.583-3.537l-.179-68.789L47.846,0H3.584A3.571,3.571,0,0,0,0,3.537Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    d: "M0,0V15.59a4.121,4.121,0,0,0,4.075,4.075h15.59",
    transform: "translate(45.886 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    d: "M0,25.4a8.732,8.732,0,0,0,8.74,8.464,8.612,8.612,0,0,0,8.74-8.464,8.732,8.732,0,0,0-8.74-8.464A8.612,8.612,0,0,1,0,8.47,8.732,8.732,0,0,1,8.74.005a8.612,8.612,0,0,1,8.74,8.464",
    transform: "translate(25.128 28.406)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    d: "M1,0V5.463",
    transform: "translate(33.961 22.943)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    d: "M1,0V5.463",
    transform: "translate(33.961 62.274)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar);
export default __webpack_public_path__ + "static/media/icon-dollar.608bc41024959c6c3ac1eafb3b29c96c.svg";
export { ForwardRef as ReactComponent };